import React from "react";
import { AuthContext } from "./auth-context";

export default function useAuth() {
  return React.useContext(AuthContext);
}